export const API_URL_LINK = "https://api.bvlmain.net/api/"
// export const API_URL_LINK = "http://localhost:8000/api/"
